<form [formGroup]="frm" (ngSubmit)="onSubmit(frm)">
  <div class="p-fluid p-formgrid grid">
    <div class="p-field col-4 md:col-4" style="padding: 0.5em;">
      <span class="p-float-label mt-5 mb-2">
        <input type="text" style="width: 100%" pInputText formControlName="firstName" autofocus Lang="ru-RU">
        <label>Фамилия</label>
      </span>
      <p-message severity="error"
        *ngIf="frm.controls['firstName'].hasError('required') && frm.controls['firstName']?.touched"
        text="Обязательное поле">
      </p-message>
    </div>
    <div class="p-field col-4 md:col-4" style="padding: 0.5em;">
      <span class="p-float-label mt-5 mb-2">
        <input type="text" style="width: 100%" pInputText formControlName="secondName">
        <label>Имя</label>
      </span>
      <p-message severity="error"
        *ngIf="frm.controls['secondName'].hasError('required') && frm.controls['secondName']?.touched"
        text="Обязательное поле">
      </p-message>
    </div>
    <div class="p-field col-4 md:col-4" style="padding: 0.5em;">
      <span class="p-float-label mt-5 mb-2">
        <input type="text" style="width: 100%" pInputText formControlName="thirdName">
        <label>Отчество</label>
      </span>
    </div>
    <div class="p-field col-3 md:col-3" style="padding: 0.5em;">
      <span class="p-float-label">
        <p-calendar formControlName="dateBirth" styleClass="calendar-compact" dataType="string" dateFormat="dd-mm-yy"
          [showIcon]="true">
        </p-calendar>
        <label>Дата рождения</label>
      </span>
      <p-message severity="error"
        *ngIf="frm.controls['dateBirth'].hasError('isValidDate') && frm.controls['dateBirth']?.touched"
        text="Некорректный формат даты. Верный формат ДД-ММ-ГГГГ"></p-message>
    </div>
    <div class="p-field col-3 md:col-3" style="padding: 0.5em;">
      <span class="p-float-label">
        <p-selectButton [options]="lstSex" formControlName="sex" dataKey></p-selectButton>
        <label></label>
      </span>
      <p-message severity="error" *ngIf="frm.controls['sex'].hasError('required') && frm.controls['sex']?.touched"
        text="Обязательное поле">
      </p-message>
    </div>
    <div class="p-field col-3 md:col-3" style="padding: 0.5em;">
      <span class="p-float-label">
        <p-dropdown [options]="lstScienceDegree" formControlName="scienceDegreeId" placeholder="Select a Science Degree"
          [resetFilterOnHide]="true"></p-dropdown>
        <label>Научная cтепень</label>
      </span>
    </div>
    <div class="p-field col-3 md:col-3" style="padding: 0.5em;">
      <span class="p-float-label">
        <p-dropdown [options]="lstScienceStatus" formControlName="scienceStatusId" placeholder="Select a Science Status"
          [resetFilterOnHide]="true"></p-dropdown>
        <label>Научное звание</label>
      </span>
    </div>
    <div class="p-field col-12" style="padding: 0.5em;">
      <span class="p-float-label mt-2 mb-2">
        <textarea style="width: 100%" type="text" rows="2" pInputTextarea formControlName="workplace"></textarea>
        <label>Место работы</label>
      </span>
    </div>
    <div class="p-field col-12" style="padding: 0.5em;">
      <span class="p-float-label">
        <p-autoComplete formControlName="position" [suggestions]="filteredPositions"
          (completeMethod)="filterPosition($event)" [minLength]="1"></p-autoComplete>
        <label>Должность</label>
      </span>
    </div>
    <div class="p-field col-12" style="padding: 0.5em;">
      <span class="p-float-label mt-2">
        <p-autoComplete formControlName="specialities" [suggestions]="fltSpecialities"
          (completeMethod)="filterSpeciality($event)" [multiple]="true" [dropdown]="true" field="label"
          [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-autoComplete>
        <label>Специальность</label>
      </span>
    </div>
    <div class="p-field col-6 md:col-6" style="padding: 0.5em;">
      <label class="custom-float-label">Телефон</label>
      <p-chips formControlName="phones" separator="," [addOnBlur]="true"></p-chips>
      <p-message severity="error" *ngIf="frm.controls['phones'].hasError('pattern') && frm.controls['phones']?.touched"
        text="Некорректный номер мобильного телефона">
      </p-message>
    </div>
    <div class="p-field col-6 md:col-6" style="padding: 0.5em;">
      <label class="custom-float-label">Email</label>
      <p-chips formControlName="emails" separator="," [addOnBlur]="true" Lang="en-US"></p-chips>
      <p-message severity="error" *ngIf="frm.controls['emails'].hasError('email') && frm.controls['emails']?.touched"
        text="Некорректный email">
      </p-message>
    </div>
    <div class="p-field col-12" style="margin-bottom: 1em">
      <div class="p-inputgroup col-4 md:col-4 pl-0 pt-0 pb-0 pr-2.5">
        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
        <p-autoComplete class="p-inputtext-sm-1" [style]="{'width':'100%'}" [suggestions]="filteredGeo$ | async"
          (input)="searchGeo$.next($event.target['value'])" (onSelect)="onSelectGeoItem($event)" field="displayName"
          [minLength]="3" placeholder="Найти город" [showEmptyMessage]="true">
        </p-autoComplete>
      </div>
    </div>
    <div class="p-field col-4 md:col-4">
      <span class="p-float-label">
        <input type="text" style="width: 100%" pInputText formControlName="city">
        <label>Город</label>
      </span>
    </div>
    <div class="p-field col-4 md:col-4">
      <span class="p-float-label">
        <input type="text" style="width: 100%" pInputText formControlName="region">
        <label>Область/Край/Республика</label>
      </span>
    </div>
    <div class="p-field col-4 md:col-4">
      <span class="p-float-label">
        <input type="text" style="width: 100%" pInputText formControlName="country">
        <label>Страна</label>
      </span>
    </div>
    <div class="p-field col-12">
      <span class="p-float-label">
        <textarea style="width: 100%" type="text" rows="2" pInputTextarea formControlName="info"></textarea>
        <label>Комментарий</label>
      </span>
    </div>

  </div>
  <!-- <pre>{{ frm.value | json }}</pre>
  <pre>{{ frm.errors | json }}</pre> -->
  <!-- <hr> -->
  <p-footer>
    <p-toolbar>
      <div class="p-toolbar-group-left">
        <button pButton class="p-button-success" icon="pi pi-check" label="Сохранить" type="submit"></button>
      </div>
      <div class="p-toolbar-group-right">
        <button pButton type="button" icon="pi pi-ban" class="p-button-secondary" label="Закрыть"
          (click)="onCancel()"></button>
      </div>
    </p-toolbar>
  </p-footer>
</form>
